import apiClient, { type PagedResponse } from '../../client'
import type {
  ValidationConfigurationItem,
  CreateValidacionRequest,
  UpdateValidacionRequest,
  GetValidacionesParams,
} from '../../models/maestros.models'

const BASE_PATH = '/maestros/validaciones-recepcion'

export const validacionesRecepcionCatalogService = {
  async getAll(params?: GetValidacionesParams): Promise<PagedResponse<ValidationConfigurationItem>> {
    return apiClient.get<PagedResponse<ValidationConfigurationItem>>(BASE_PATH, params)
  },
  async getById(id: string): Promise<ValidationConfigurationItem> {
    return apiClient.get<ValidationConfigurationItem>(`${BASE_PATH}/${id}`)
  },
  async create(data: CreateValidacionRequest): Promise<ValidationConfigurationItem> {
    return apiClient.post<ValidationConfigurationItem, CreateValidacionRequest>(BASE_PATH, data)
  },
  async update(id: string, data: UpdateValidacionRequest): Promise<ValidationConfigurationItem> {
    return apiClient.put<ValidationConfigurationItem, UpdateValidacionRequest>(
      `${BASE_PATH}/${id}`,
      data,
    )
  },
  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },
}
